;(function (angular, _) {
  'use strict'

  class EditSubcontractorModalController {
    constructor (
      // Angular
      // Libs
      // Managers
      // Services
      // Const
      // Resolved
      subcontractor
    ) {
      // DI
      this.subcontractor = subcontractor
      if (!this.subcontractor.address) {
        this.subcontractor.address = {}
      }
    }
  }

  EditSubcontractorModalController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    'subcontractor'
  ]

  angular.module('kilo.routes.subcontractor')
    .controller('EditSubcontractorModalController', EditSubcontractorModalController)
})(window.angular, window._)

